import React from 'react';

interface TransactionalEmailProps {
  userName: string;
  courseName: string;
  courseDate: string;
  courseDuration: string;
  instructor: string;
  modality: string;
  courseId: string;
  session: string;
  time: string;
  address: string;
  meetingLink: string;
  companyName: string;
}

const TransactionalEmail: React.FC<TransactionalEmailProps> = ({
  userName,
  courseName,
  courseDate,
  courseDuration,
  instructor,
  modality,
  courseId,
  session,
  time,
  address,
  meetingLink,
  companyName
}) => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', backgroundColor: '#f6f9fc' }}>
      {/* Header */}
      <div style={{ backgroundColor: '#ffffff', padding: '20px', textAlign: 'center', borderBottom: '1px solid #eeeeee' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#333', margin: '0' }}>{companyName}</h1>
      </div>

      {/* Main Content */}
      <div style={{ backgroundColor: '#ffffff', border: '1px solid #eeeeee', borderRadius: '5px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)', padding: '40px', margin: '20px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '24px' }}>
          Confirmação de Aula
        </h2>

        <p style={{ fontSize: '16px', lineHeight: '24px', color: '#555', margin: '16px 0' }}>
          Olá, <strong>{userName}</strong>!
        </p>

        <p style={{ fontSize: '16px', lineHeight: '24px', color: '#555', margin: '16px 0' }}>
          Sua aula foi confirmada com sucesso. Abaixo estão os detalhes:
        </p>

        {/* Course Details */}
        <div style={{ backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '24px 0' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginBottom: '16px' }}>
            Detalhes da Aula
          </h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '14px' }}>
            <div>
              <strong style={{ color: '#666' }}>Curso:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{courseName}</div>
            </div>
            
            <div>
              <strong style={{ color: '#666' }}>Data:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{courseDate}</div>
            </div>
            
            <div>
              <strong style={{ color: '#666' }}>Horário:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{time}</div>
            </div>
            
            <div>
              <strong style={{ color: '#666' }}>Duração:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{courseDuration}</div>
            </div>
            
            <div>
              <strong style={{ color: '#666' }}>Instrutor:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{instructor}</div>
            </div>
            
            <div>
              <strong style={{ color: '#666' }}>Modalidade:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{modality}</div>
            </div>
            
            <div>
              <strong style={{ color: '#666' }}>Sessão:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{session}</div>
            </div>
            
            <div>
              <strong style={{ color: '#666' }}>ID do Curso:</strong>
              <div style={{ color: '#333', marginTop: '4px' }}>{courseId}</div>
            </div>
          </div>
          
          <div style={{ marginTop: '16px' }}>
            <strong style={{ color: '#666' }}>Local/Endereço:</strong>
            <div style={{ color: '#333', marginTop: '4px' }}>{address}</div>
          </div>
        </div>

        {/* Meeting Link */}
        {modality.toLowerCase() === 'online' && meetingLink && (
          <div style={{ textAlign: 'center', margin: '32px 0' }}>
            <a 
              href={meetingLink}
              style={{
                backgroundColor: '#3182ce',
                borderRadius: '4px',
                color: '#fff',
                fontSize: '16px',
                fontWeight: 'bold',
                textDecoration: 'none',
                padding: '12px 24px',
                display: 'inline-block'
              }}
            >
              Acessar Aula Online
            </a>
          </div>
        )}

        {/* Instructions */}
        <div style={{ backgroundColor: '#e8f4fd', padding: '16px', borderRadius: '6px', margin: '24px 0' }}>
          <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#1e40af', marginBottom: '8px' }}>
            Instruções Importantes:
          </h4>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#1e40af' }}>
            <li>Chegue com 10 minutos de antecedência</li>
            <li>Tenha seu material de estudo em mãos</li>
            <li>Para aulas online, teste seu microfone e câmera</li>
            <li>Em caso de dúvidas, entre em contato conosco</li>
          </ul>
        </div>

        <hr style={{ borderColor: '#e2e8f0', margin: '32px 0' }} />

        <p style={{ fontSize: '14px', color: '#666', margin: '8px 0' }}>
          Se você tiver alguma dúvida, basta responder a este email ou entrar em contato com nosso suporte.
        </p>

        <p style={{ fontSize: '14px', color: '#666', margin: '8px 0' }}>
          Atenciosamente,<br />
          Equipe {companyName}
        </p>

        <p style={{ fontSize: '12px', color: '#999', margin: '16px 0 8px' }}>
          Se você não solicitou este email, pode ignorá-lo com segurança.
        </p>

        <a 
          href="https://trivium.com.br" 
          style={{ color: '#3182ce', textDecoration: 'none', fontSize: '12px' }}
        >
          trivium.com.br
        </a>
      </div>
    </div>
  );
};

export default TransactionalEmail;
